<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      @openAddDialog="createClose()"
      @success="onSuccess"
      :submitService="submitService"
      :submitData="submitData"
      addShowPower="/tatbankprofit/add"
      :buttonName="setBtnName"
    >
      <el-form-item label="通道名称">
        <el-select v-model="formModel.chnId">
          <el-option
            v-for="item in bankChn"
            :key="item.id"
            :label="item.chnName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="formModel.status">
          <el-option
            v-for="item in checkStatus"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="chnName"
        label="通道名称"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="closeAmt"
        label="结算金额"
        min-width="130"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ scope.row.closeAmt == null ? 0 : scope.row.closeAmt / 100 }}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="launchUser"
        label="发起人"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="checkUser"
        label="审核人"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p v-if="scope.row.status == 1">待审核</p>
          <p v-if="scope.row.status == 2">成功</p>
          <p v-if="scope.row.status == 3">驳回</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="launchTime"
        label="发起时间"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="checkTime"
        label="审核时间"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="操作"
        min-width="120"
        v-if="hasPerm('/tatbankprofit/check')"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="updateInfo(scope.row.id)"
            v-if="hasPerm('/tatbankprofit/check')"
            >审核
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="launchRef"
      :formDialogTitle="formDialogTitle"
      :model="launchModel"
      :dialogService="launchProfitService"
      :submitData="launchData"
      :rules="dialogRules"
      class="over"
      @success="dialogSuccess"
      @close="dialogClose"
      labelWidth="150px"
    >
      <el-form-item label="通道名称">
        <el-select v-model="launchModel.chnId">
          <el-option
            v-for="item in bankChn"
            :key="item.id"
            :label="item.chnName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始时间">
        <el-date-picker
          v-model="launchModel.startTime"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间">
        <el-date-picker
          v-model="launchModel.endTime"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结算金额" prop="closeAmt">
        <el-input
          type="text"
          v-bind:readonly="true"
          v-model="launchModel.closeAmt"
        ></el-input>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
// import BankChnService from 'service/BankChnService'
import TatBankProfitService from "service/TatBankProfitService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "tatBankProfit",
  data() {
    return {
      dialogRules: {
        chnId: [
          {
            required: true,
            message: "请选择通道",
          },
        ],
        startTime: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请选开始时间"));
              }
            },
          },
        ],
        endTime: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请选结束时间"));
              }
            },
          },
        ],
      },
      bankChn: [],
      checkStatus: [
        { id: "", value: "全部" },
        { id: "1", value: "待审核" },
        { id: "2", value: "成功" },
        { id: "3", value: "驳回" },
      ],
      dictInfo: [],
      formModel: {
        chnId: "",
        status: "",
      },
      launchModel: {
        chnId: "",
        startTime: "",
        endTime: "",
        closeAmt: "",
      },
      tableData: [],
      formDialogTitle: "发起结算",
      submitService: TatBankProfitService.list,
      launchProfitService: TatBankProfitService.create,
      page: [],
      chnNameList: [],
      getChnName: "",
      getChnCode: "",
      status: "",
      showMsg: "",
      channelId: "",
      isPage: false,
    };
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  mounted() {
    this.page = this.$refs.commonTable.page;
    this.getList();
    this.getBankChn();
  },
  computed: {
    submitData() {
      this.params = {
        chnId: this.formModel.chnId,
        status: this.formModel.status,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return this.params;
    },
    setBtnName() {
      return "发起结算";
    },
    launchData() {
      this.params = {
        chnId: this.launchModel.chnId,
        startTime: this.launchModel.startTime,
        endTime: this.launchModel.endTime,
        closeAmt: this.launchModel.closeAmt,
        launchUserId: this.userId,
      };
      return this.params;
    },
    dialogService() {
      return TatBankProfitService.update;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  methods: {
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        TatBankProfitService.list,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.tableData = result.rows;
            this.page.currentPage = result.current;
            this.page.total = result.total;
            this.page.pageSize = result.size;
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    getBankChn() {
      this.doLoad(
        BankChnService.comboBoxList,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.bankChn = res.contents;
          });
        },
        "信息获取失败"
      );
    },
    createClose() {
      this.$refs.launchRef.open();
    },
    getDetail(id, chnName) {
      const params = {
        id: id,
        userId: this.userId,
      };
      this.doLoad(
        BankSettingService.detail,
        params,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.dialogModel = result;
            this.dialogModel.chnName = chnName;
            //this.getList();
          });
        },
        "操作失败"
      );
    },
    onSuccess(data) {
      const result = data.contents;
      this.tableData = result.rows;
      this.page.currentPage = result.current;
      this.page.total = result.total;
      this.page.pageSize = result.size;
    },
    dialogSuccess(data) {
      if (data.respCode == "0000") {
        this.showSuccess(data.contents.optMsg);
        this.$refs.formDialog.closeDialog();
        this.getList();
      } else {
        this.showError(data.respMsg);
      }
    },
    dialogClose() {
      this.dialogModel = {
        realName: "",
        chnCode: "",
        chnName: "",
        conPerson: "",
        conTel: "",
      };
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/CreditCardManage/TatBankProfit.vue